module.exports = __webpack_public_path__ + "img/SKMJ_cap5.e6c79a89.jpg";